// Profile uses the same sidebar section pattern as Settings. These entries
// also supply its page headings; the existing profile addresses stay unchanged.
import type { Component } from 'vue'
import { PhArrowLeft, PhBell, PhCalendarDots, PhEnvelopeSimple, PhUserCircle } from '@phosphor-icons/vue'
import type { FeatureFlag } from '@/types'

export type ProfileSection = 'profile' | 'email' | 'calendar' | 'notifications'

export interface ProfileNavItem {
  id: ProfileSection
  route: string
  labelKey: string
  titleKey?: string
  icon: Component
  requiredFeature?: FeatureFlag
}

export const PROFILE_BACK_ICON = PhArrowLeft
export const PROFILE_NAV_ITEMS: ProfileNavItem[] = [
  { id: 'profile', route: '/profile', labelKey: 'profile.tabs.profile', titleKey: 'profile.title', icon: PhUserCircle },
  { id: 'email', route: '/profile/email', labelKey: 'profile.tabs.email', icon: PhEnvelopeSimple },
  { id: 'calendar', route: '/profile/calendar', labelKey: 'profile.tabs.calendar', icon: PhCalendarDots, requiredFeature: 'customers' },
  { id: 'notifications', route: '/profile/notifications', labelKey: 'profile.tabs.notifications', icon: PhBell },
]
